<script setup lang="ts">
import type { DefineComponent } from 'vue';
import { computed } from 'vue';

// import type { ThemeTextColor } from '@/theme/types';
// import { computedClass, computedStyle } from '@/theme/theme.service';

export interface PlsTextProps {
  /**
   * The component to render.
   * @defaultValue `'span'`
   */
  component?: string | DefineComponent | null;
  // color?: ThemeTextColor;
  sizeVariant?: 'base' | 'title' | 'subtitle' | 'body' | 'caption' | 'button';
  colorVariant?: 'none' | 'error';
}
const props = withDefaults(defineProps<PlsTextProps>(), {
  component: 'span',
  color: 'default',
  sizeVariant: 'base',
  colorVariant: 'none',
});

const renderItem = computed(() => props.component || 'span');

// const typographyStyle = computedStyle((_, theme) => {
//   // const color = props.color || theme.darkerText;
//   // return { color };
//   return {};
// });

const sizeClasses = computed(() => {
  const { sizeVariant } = props;

  return {
    'theme-font-main': sizeVariant === 'base',
    'theme-font-h4': sizeVariant === 'title',
    'text-lg': sizeVariant === 'subtitle',
    'text-sm': sizeVariant === 'caption',
    'text-xs': sizeVariant === 'button',
  };
});

const colorClasses = computed(() => {
  const { colorVariant } = props;

  // const errorTextClass = computedClass((_, theme) => ({
  //   color: theme.errorColor,
  // }));

  return {
    '': colorVariant === 'none',
    // [errorTextClass.value]: colorVariant === 'error',
  };
});
</script>

<template>
  <!-- :style="typographyStyle" -->
  <component :is="renderItem" class="pls-text" :class="[sizeClasses, colorClasses]" v-bind="$attrs" v-on="$listeners">
    <slot />
  </component>
</template>

<style scoped>
.pls-text {
  line-height: 1.5;
}
</style>
